import { v4 as uuid } from "uuid";

import { IBrief } from "../../briefs";
import { EntityTypes } from "../../EntityTypes";
import { IMissionResource } from "../../missions";
import { IUser } from "../../users";
import { createApiMutationHook, type IApiMutationFunction } from "../../utils/api";
import { mapRelationalValueAsIRI, type RelationalValue } from "../../utils/filters";
import type { IFollowUp } from "../types/IFollowUp";

export interface IFollowUpCreateMutationParameters {
    uuid?: string;
    learner: RelationalValue<IUser>;
    briefs?: RelationalValue<IBrief>[];
    progression?: string;
    autonomy?: string;
    strength?: string;
    improvement?: string;
    more?: string;
    periodStart: string;
    periodEnd: string;
    periodType?: string[];
    waypoint: string;
    title: string;
    missions?: RelationalValue<IMissionResource>[];
}

export type IFollowUpCreateMutationResult = IFollowUp;

export const followUpCreateMutation: IApiMutationFunction<IFollowUpCreateMutationParameters> = ({
    uuid: providedUuid,
    learner,
    briefs,
    missions,
    progression,
    autonomy,
    strength,
    improvement,
    more,
    periodStart,
    periodEnd,
    periodType,
    waypoint,
    title,
}) => ({
    method: "POST",
    url: "/follow_ups",
    data: {
        uuid: providedUuid ?? uuid(),
        learner: mapRelationalValueAsIRI(EntityTypes.USER, learner),
        briefs: briefs?.map(brief => mapRelationalValueAsIRI(EntityTypes.BRIEF, brief)),
        missions: missions?.map(mission => mapRelationalValueAsIRI(EntityTypes.MISSION, mission)),
        progression,
        autonomy,
        strength,
        improvement,
        more,
        periodStart,
        periodEnd,
        periodType,
        waypoint,
        title,
    },
});

export const useFollowUpCreateMutation = createApiMutationHook<
    IFollowUpCreateMutationParameters,
    IFollowUpCreateMutationResult
>(followUpCreateMutation);
